var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'no-results',
    {
      'no-results--small': _vm.small,
      'no-results--design-new': _vm.design === 'new'
    }
  ],style:({ marginTop: `${_vm.marginTop}px`, marginBottom: `${_vm.marginBottom}px` })},[(!_vm.small)?[(_vm.design === 'new')?_c('span',{staticClass:"no-results__icon",attrs:{"aria-hidden":"true"}}):_c('img',{attrs:{"src":require("@/assets/img/schedule-plug-icon.svg"),"alt":""}})]:_vm._e(),_c('div',{staticClass:"no-results__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"no-results__text"},[_vm._v(_vm._s(_vm.text))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }